module.exports = __webpack_public_path__ + "static/img/BookingHover.e061f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/BookingHover.png
// module id = mfX7
// module chunks = 0